import { RouteRecordRaw } from 'vue-router';

export const monthlyActivityRouters: RouteRecordRaw[] = [
  {
    path: '/monthlyActivity',
    name: 'MonthlyActivity',
    component: () => import('@/pages/h5/MonthlyActivity/Home.vue'),
    meta: { title: '月度推广现金奖', disabledNavBar: true },
  },
  { path: '/monthlyActivity/rank', name: 'MonthlyActivityRank', component: () => import('@/pages/h5/MonthlyActivity/Rank.vue'), meta: { title: '实时积分榜', disabledNavBar: true } },
  { path: '/monthlyActivity/winners', name: 'MonthlyActivityWinners', component: () => import('@/pages/h5/MonthlyActivity/Winners.vue'), meta: { title: '中奖公示', disabledNavBar: true } },
  { path: '/monthlyActivity/score-detail', name: 'MonthlyActivityScoreDetail', component: () => import('@/pages/h5/MonthlyActivity/ScoreDetail.vue'), meta: { title: '我的积分', disabledNavBar: true } },
  { path: '/monthlyActivity/rules', name: 'MonthlyActivityRules', component: () => import('@/pages/h5/MonthlyActivity/Rules.vue'), meta: { title: '活动规则', disabledNavBar: true } },
  { path: '/monthlyActivity/vouchers', name: 'MonthlyActivityVouchers', component: () => import('@/pages/h5/MonthlyActivity/Vouchers.vue'), meta: { title: '活动打款凭证', disabledNavBar: true } },
];
